import Model from "@/models/Model"

export default class AChangeBranchOffice extends Model {
    resource() {
        return "change_branch_office"
    }
}